<template>
  <el-dialog :title="title" :visible.sync="visible" width="94%" top="4vh" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="beforeClose" append-to-body custom-class="ai-scene-configuration">
    <div v-loading="loading" class="configuration-content">
      <el-alert v-if="error" :title="error" type="error" :closable="false">
        <el-button type="text" @click="loadScene">重新加载场景</el-button>
      </el-alert>
      <template v-if="scene && !loading && !error">
        <div v-if="kind === 'auth'" class="configuration-scope">
          <el-radio-group :value="targetType" :disabled="saving" size="small" @input="changeScope">
            <el-radio-button label="scene">当前场景</el-radio-button>
            <el-radio-button v-if="scene.categoryId" label="category">所属分类下场景（批量）</el-radio-button>
          </el-radio-group>
          <span v-if="targetType === 'category'" class="category-name">{{ scene.categoryName || '当前所属分类' }}</span>
        </div>
        <audience-authorization v-if="kind === 'auth'" :key="target.type + ':' + target.id" ref="panel" :fixed-target="target" @busy-change="saving = $event" />
        <score-template v-else :key="scene.id" ref="panel" :fixed-scene="scene" @busy-change="saving = $event" />
      </template>
    </div>
    <div slot="footer"><el-button :disabled="saving" @click="beforeClose(close)">关闭</el-button></div>
  </el-dialog>
</template>

<script>
import sceneApi from '@/api/aiTrain/scene'
import AudienceAuthorization from '../common/AudienceAuthorization'
import ScoreTemplate from '../scoreTemplate/index'

export default {
  name: 'AiTrainSceneConfigurationDialog',
  components: { AudienceAuthorization, ScoreTemplate },
  data() {
    return { visible: false, kind: 'auth', targetType: 'scene', requestedId: null, scene: null, loading: false, saving: false, error: '', sequence: 0 }
  },
  computed: {
    title() { return (this.kind === 'auth' ? '场景授权' : '场景评分表') + (this.scene ? ' · ' + this.scene.title : '') },
    target() { return this.targetType === 'category' ? { type: 'category', id: this.scene.categoryId, name: this.scene.categoryName } : { type: 'scene', id: this.scene.id, name: this.scene.title } }
  },
  beforeDestroy() { ++this.sequence },
  methods: {
    open(scene, kind = 'auth') {
      const id = Number(scene && scene.id)
      if (!Number.isSafeInteger(id) || id <= 0) { this.$message.warning('请先保存场景，再配置评分表和授权'); return }
      this.requestedId = id
      this.kind = kind
      this.targetType = 'scene'
      this.scene = null
      this.visible = true
      this.saving = false
      this.loadScene()
    },
    loadScene() {
      const sequence = ++this.sequence
      this.loading = true
      this.error = ''
      return sceneApi.fetchById(this.requestedId).then(res => {
        if (sequence !== this.sequence || !this.visible) return
        const detail = res && res.data
        if (!detail || Number(detail.id) !== this.requestedId || !detail.title) throw new Error('场景信息不可用')
        this.scene = { ...detail, id: Number(detail.id) }
      }).catch(() => {
        if (sequence === this.sequence) this.error = '场景读取失败，请重新加载后配置，避免修改错误对象。'
      }).finally(() => { if (sequence === this.sequence) this.loading = false })
    },
    discardThen(action) {
      if (this.saving) { this.$message.warning('正在保存，请稍候'); return }
      const panel = this.$refs.panel
      if (panel && panel.isDirty) {
        return this.$common.confirm('当前修改尚未保存，是否放弃修改？').then(() => { if (!this.saving) action() }).catch(() => {})
      }
      action()
    },
    changeScope(value) {
      if (value === this.targetType || !['scene', 'category'].includes(value) || (value === 'category' && !this.scene.categoryId)) return
      return this.discardThen(() => { this.targetType = value })
    },
    beforeClose(done) { this.discardThen(() => { ++this.sequence; this.scene = null; done() }) },
    close() { this.visible = false }
  }
}
</script>

<style scoped>
.configuration-content { min-height: 160px; }
.configuration-scope { display: flex; align-items: center; gap: 16px; margin-bottom: 16px; }
.category-name { color: #606266; }
</style>
<style>
.ai-scene-configuration { max-width: 1200px; }
.ai-scene-configuration .el-dialog__body { padding-top: 12px; }
</style>
